// extracted by mini-css-extract-plugin
export default {"container":"ImageComponent_container__KUm2F","title_h4":"ImageComponent_title_h4__nfQyp"};